import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { TreeItem } from '../../models/tree-item';
import { ConnectProviderService } from 'app/connect/core/connect-provider.service';
import { I18nService } from 'i18n/i18n.service';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { ShowToastService } from 'app/shared/services/showToast.service';
import { DateUtil } from 'app/core/utils/DateUtil';
import { DateUtilDST } from 'app/core/utils/DateUtilDST';

@Component({
  selector: 'connect-replication-detail-schedule',
  templateUrl: 'connect-replication-detail-schedule.component.html',
  styleUrls: ['connect-replication-detail-schedule.component.scss']
})
export class ConnectReplicationDetailScheduleComponent implements OnInit, AfterViewChecked, OnChanges {

  public enableReplication: boolean = true;
  public showErrorStarting: boolean = false;
  public limitMinimumDate: boolean = false;
  public limitMaxDate: boolean = false;

  public minutesEndingAt: string = '00';
  public minutesStartingAt: string = '00';
  public hoursEndingAt: string = '00';
  public hoursStartingAt: string = '00';

  public dailyFrecuency: string = 'Once';
  public frecuencyType: string = '0';
  public occursEvery: string = 'Minutes';
  public startDateField: string = '';

  public beginningDate: Date = new Date();

  public schedule: any = null;
  public scheduleObj: any = null;
  public changeSet: any = {};
  public daysOfWeek: Array<string> = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  public daysOfWeekSelected: Array<string> = [];
  public startDate = new Date();
  public endDate = new Date();
  public dayOfTheMonthSelected: number = 1;


  @Input() currentItemSelected: TreeItem;

  constructor(private _connectProviderService: ConnectProviderService,
    private _i18nService: I18nService,
    private _toastService: BzgToastService,
    private cdRef: ChangeDetectorRef,
    private _showToastService: ShowToastService) {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.defaultValues();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  defaultValues() {
    this._connectProviderService.getInfoById(this.currentItemSelected.id).subscribe((data: any) => {
      this.scheduleObj = data;
      this.schedule = data.content.schedules[0];
      this.enableReplication = this.scheduleObj.content.enabled;
      this.setValues();
    });
  }

  setValues() {
    this.startDate = new Date(DateUtilDST.normalizeUtcToTimeZone(this.schedule.startDate));
    this.startDateField = DateUtil.formatDateShort(this.startDate);
    this.endDate = new Date(DateUtilDST.normalizeUtcToTimeZone(`${this.schedule.startDate.split('T')[0]}T${this.schedule.endHour}`));
    this.hoursStartingAt = DateUtilDST.getHour(this.startDate);
    this.minutesStartingAt = DateUtilDST.getMinutes(this.startDate);

    if (this.schedule.frequency.type === 'Weekly') {
      this.daysOfWeekSelected = this.configuredDaysFromUTC();
    }
    if (this.schedule.frequency.type === 'Monthly') {
      this.dayOfTheMonthSelected = this.configuredDayOfMonthFromUTC();
    }

    if (this.schedule.dailyExecution.type !== 'Once') {
      this.dailyFrecuency = 'Every';
      this.occursEvery = this.schedule.dailyExecution.type;
      this.hoursEndingAt = DateUtilDST.getHour(this.endDate);
      this.minutesEndingAt = DateUtilDST.getMinutes(this.endDate);
    }
    else {
      this.minutesEndingAt = '00';
      this.hoursEndingAt = '00';
      this.dailyFrecuency = 'Once';
      this.showErrorStarting = false;
    }
    this.validateDates();
  }

  changeEnableReplication() {
    this.scheduleObj.content.enabled = !this.scheduleObj.content.enabled;
    this.enableReplication = this.scheduleObj.content.enabled;
  }

  changeFrequency(valueFrecuency) {
    this.schedule.frequency.type = valueFrecuency;
  }

  changeDaysOfWeek(days) {
    this.daysOfWeekSelected = days;
  }

  changeFrequencyRecurrence(recurrence) {
    this.schedule.frequency.recurrence = recurrence;
  }

  changeDayOfMonth(dayOfMonth) {
    this.dayOfTheMonthSelected = dayOfMonth;
  }

  changeDailyFrecuency(frequency) {
    this.dailyFrecuency = frequency;
    this.showErrorStarting = false;
    if (this.dailyFrecuency === 'Once') {
      this.schedule.dailyExecution.type = frequency;
      this.schedule.dailyExecution.recurrence = 0;
    }
    else
      this.schedule.dailyExecution.type = this.occursEvery;
  }

  changeEverySelected(occursEvery) {
    this.schedule.dailyExecution.type = occursEvery;
    this.occursEvery = occursEvery;
  }

  changeDailyFrequencyRecurrence(dailyFrequencyRecurrence) {
    this.schedule.dailyExecution.recurrence = dailyFrequencyRecurrence;
  }

  changeStartDate(startDate) {
    this.startDate = DateUtilDST.setDate(this.startDate, startDate);
    this.endDate = DateUtilDST.setDate(this.endDate, startDate);

    this.validateDates();
  }

  onCancel() {
    this.defaultValues();
  }

  saveAll() {
    this.schedule.startDate = DateUtilDST.formatDateShortWithTimeUTC(this.startDate);
    this.schedule.startHour = DateUtilDST.formatTimeWithTimeUTC(this.startDate);

    if (this.dailyFrecuency === 'Once') {
      this.schedule.endHour = '00:00:00';
    } else {
      this.schedule.endHour = DateUtilDST.formatTimeWithTimeUTC(this.endDate);
    }

    if (this.schedule.frequency.type === 'Weekly') {
      this.schedule.daysOfWeek = this.configuredDaysToUTC();
    } else {
      this.schedule.daysOfWeek = [];
    }

    if (this.schedule.frequency.type === 'Monthly') {
      this.schedule.dayOfMonth = this.configuredDayOfMonthToUTC();
    }
    else {
      this.schedule.dayOfMonth = 0;
    }
    this.scheduleObj.action = 'Merge';
    this.scheduleObj.content.schedules[0] = {};
    this.scheduleObj.content.schedules[0] = this.schedule;
    this._connectProviderService.postSchedule(this.scheduleObj).subscribe(result => {
      this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
    });
  }


  configuredDayOfMonthToUTC() {
    const hoursStartingAt = parseInt(this.hoursStartingAt, 10);
    const offsetConfigured = DateUtil.getConfiguredOffSetInMinutes() / 60;
    const offset = hoursStartingAt < offsetConfigured ? -1 : (hoursStartingAt >= (24 + offsetConfigured) ? 1 : 0);

    return this.dayOfTheMonthSelected + offset > 30 ? 1 : this.dayOfTheMonthSelected + offset < 1 ? 30 : this.dayOfTheMonthSelected + offset;
  }

  configuredDayOfMonthFromUTC() {
    const hoursStartingAt = parseInt(this.hoursStartingAt, 10);
    const offsetConfigured = DateUtil.getConfiguredOffSetInMinutes() / 60;
    const offset = hoursStartingAt < offsetConfigured ? -1 : (hoursStartingAt >= (24 + offsetConfigured) ? 1 : 0);

    return this.schedule.dayOfMonth - offset < 1 ? 30 : this.schedule.dayOfMonth - offset > 30 ? 1 : this.schedule.dayOfMonth - offset;
  }

  configuredDaysFromUTC() {
    let days = [];
    const hoursStartingAt = parseInt(this.hoursStartingAt, 10);
    const offsetConfigured = DateUtil.getConfiguredOffSetInMinutes() / 60;
    const offset = hoursStartingAt < offsetConfigured ? -1 : (hoursStartingAt >= (24 + offsetConfigured) ? 1 : 0);

    if (offset !== 0) {
      for (let i = 0; i < this.schedule.daysOfWeek.length; i++) {
        const indexofDay = this.daysOfWeek.indexOf(this.schedule.daysOfWeek[i]);
        const newIndex = (indexofDay - offset + 7) % 7;
        days.push(this.daysOfWeek[newIndex]);
      }
    }
    else {
      days = this.schedule.daysOfWeek;
    }

    return days;
  }

  configuredDaysToUTC() {
    let days = [];
    const hoursStartingAt = parseInt(this.hoursStartingAt, 10);
    const offsetConfigured = DateUtil.getConfiguredOffSetInMinutes() / 60;
    const offset = hoursStartingAt < offsetConfigured ? -1 : (hoursStartingAt >= (24 + offsetConfigured) ? 1 : 0);

    if (offset !== 0) {
      for (let i = 0; i < this.daysOfWeekSelected.length; i++) {
        const indexofDay = this.daysOfWeek.indexOf(this.daysOfWeekSelected[i]);
        const newIndex = (indexofDay + offset + 7) % 7;
        days.push(this.daysOfWeek[newIndex]);
      }
    }
    else {
      days = this.daysOfWeekSelected;
    }

    return days;
  }

  showErrorWeek() {
    return this.schedule && this.schedule.frequency.type === 'Weekly' &&
      (!this.daysOfWeekSelected || this.daysOfWeekSelected.length === 0);
  }

  changeOccursEvery(selectedValue, isHour, isEndingAt) {
    if (!isEndingAt)
      if (isHour)
        this.startDate = DateUtilDST.setHour(this.startDate, parseInt(selectedValue));
      else
        this.startDate = DateUtilDST.setMinutes(this.startDate, parseInt(selectedValue));
    else
      if (isHour)
        this.endDate = DateUtilDST.setHour(this.endDate, parseInt(selectedValue));
      else
        this.endDate = DateUtilDST.setMinutes(this.endDate, parseInt(selectedValue));

    this.hoursStartingAt = DateUtilDST.getHour(this.startDate);
    this.minutesStartingAt = DateUtilDST.getMinutes(this.startDate);
    this.hoursEndingAt = DateUtilDST.getHour(this.endDate);
    this.minutesEndingAt = DateUtilDST.getMinutes(this.endDate);
    this.validateDates();
  }

  validateDates() {
    this.showErrorStarting = ((DateUtilDST.getHour(this.endDate) < DateUtilDST.getHour(this.startDate)) || ((DateUtilDST.getHour(this.endDate) === DateUtilDST.getHour(this.startDate)) && (DateUtilDST.getMinutes(this.endDate) < DateUtilDST.getMinutes(this.startDate)))) && this.dailyFrecuency !== 'Once' ? true : false;
    const year = this.startDate.getFullYear();
    if (year > 3000)
      this.limitMaxDate = true;
    else
      this.limitMaxDate = false;
    if (year < 1753)
      this.limitMinimumDate = true;
    else
      this.limitMinimumDate = false;

  }
}
